module.exports = __webpack_public_path__ + "img/Wp_2091.f96a3966.png";